import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmbedTokenRequest } from '@shared';

@Injectable()
export class PBIService extends ApiService<string> {
  constructor(http: HttpClient) {
    super(http);
  }

  fetchEmbedToken(body: EmbedTokenRequest): Observable<any> {
    return this.post({ url: 'power-bi/get-embed-token', body }).pipe(
      map((response: any) => response),
      catchError((error) => {
        console.error('Failed while trying to get the token: ' + error);
        return EMPTY;
      }),
    );
  }
}
